import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { AuthService } from '@ipg/ngx-frontend-toolset';
import { AuthViewComponent } from '../auth/components/auth-view/auth-view.component';

/**
 * Landing page for an authenticated user who holds no permissions at all.
 *
 * `defaultRedirectGuard` used to fall back to '/settings', chosen because it
 * was ungated and so could always terminate the redirect chain. That made the
 * settings pages the one thing a user with no role could see — the opposite of
 * what having no role should mean. The settings routes now carry guards of
 * their own, and this page is the terminal fallback instead: deliberately
 * ungated, and holding nothing but an explanation and a way out.
 */
@Component({
  selector: 'app-no-access',
  imports: [AuthViewComponent, MatButton],
  templateUrl: './no-access.component.html',
  styleUrl: './no-access.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoAccessComponent {
  private readonly _auth = inject(AuthService);

  logout(): void {
    this._auth.logout().subscribe();
  }
}
